{
	"communities": [
		{
			"name": "Utrecht",
			"lat": 52.09073739999999,
			"lon": 5.081420100000023,
			"link": "",
			"parent_name": "Netherlands"
		},
		{
			"name": "Nottingham",
			"lat": 52.9548,
			"lon": -1.1581,
			"link": "",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Edinburgh",
			"lat": 55.9533,
			"lon": -3.1883,
			"link": "",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Manchester",
			"lat": 53.4808,
			"lon": -2.2426,
			"link": "",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Copenhagen",
			"lat": 55.6761,
			"lon": 12.5683,
			"link": ""
		},
		{
			"name": "London",
			"lat": 51.5073509,
			"lon": -0.12775829999998223,
			"link": "https://pauseai.uk/london/",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Rosario",
			"lat": -32.9442,
			"lon": -60.6505,
			"link": "$$DISCORD_US$$"
		},
		{
			"name": "Paris",
			"lat": 48.8647,
			"lon": 2.349,
			"link": "$$DISCORD_FRANCE$$",
			"parent_name": "France"
		},
		{
			"name": "Montreal",
			"lat": 45.5088,
			"lon": -73.5616,
			"link": "https://pauseai.ca/montreal.html",
			"parent_name": "Canada"
		},
		{
			"name": "Nairobi",
			"lat": -1.286389,
			"lon": 36.817223,
			"link": "",
			"parent_name": "Kenya"
		},
		{
			"name": "Stockholm",
			"lat": 59.3293,
			"lon": 18.0686,
			"link": "",
			"parent_name": "Sweden"
		},
		{
			"name": "Marseille",
			"lat": 43.2963,
			"lon": 5.37,
			"link": "$$DISCORD_FRANCE$$",
			"parent_name": "France"
		},
		{
			"name": "São Paulo",
			"lat": -23.5338,
			"lon": -46.6253,
			"link": ""
		},
		{
			"name": "Fredrikstad",
			"lat": 59.2201,
			"lon": 10.9299,
			"link": ""
		},
		{
			"name": "Lucerne",
			"lat": 47.0502,
			"lon": 8.3093,
			"link": "",
			"parent_name": "Switzerland"
		},
		{
			"name": "Berlin",
			"lat": 52.52,
			"lon": 13.405,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Rome",
			"lat": 41.8967,
			"lon": 12.482,
			"link": "",
			"parent_name": "Italy"
		},
		{
			"name": "Toronto",
			"lat": 43.6511,
			"lon": -79.347,
			"link": "",
			"parent_name": "Canada"
		},
		{
			"name": "Amsterdam",
			"lat": 52.378,
			"lon": 4.8971,
			"link": "https://chat.whatsapp.com/EOGvhoPCiCqDqwuf9JUxtB",
			"parent_name": "Netherlands"
		},
		{
			"name": "München",
			"lat": 48.137,
			"lon": 11.576,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Cambridge",
			"lat": 52.2053,
			"lon": 0.1192,
			"link": "",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Hanoi",
			"lat": 21.0285,
			"lon": 105.8048,
			"link": ""
		},
		{
			"name": "Gdynia",
			"lat": 54.5168,
			"lon": 18.5419,
			"link": "",
			"parent_name": "Poland"
		},
		{
			"name": "Blackpool",
			"lat": 53.8159,
			"lon": -3.0553,
			"link": "",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Vancouver",
			"lat": 49.2463,
			"lon": -123.1162,
			"link": "",
			"parent_name": "Canada"
		},
		{
			"name": "Melbourne",
			"lat": -37.8136,
			"lon": 144.9631,
			"link": "https://www.pauseai.org.au",
			"parent_name": "Australia"
		},
		{
			"name": "Zurich",
			"lat": 47.3769,
			"lon": 8.5417,
			"link": "",
			"parent_name": "Switzerland"
		},
		{
			"name": "Milan",
			"lat": 45.4642,
			"lon": 9.19,
			"link": "",
			"parent_name": "Italy"
		},
		{
			"name": "Kraków",
			"lat": 50.0647,
			"lon": 19.945,
			"link": "",
			"parent_name": "Poland"
		},
		{
			"name": "Yaoundé",
			"lat": 3.848,
			"lon": 11.5027,
			"link": "https://chat.whatsapp.com/EmSo5C486JzDdFOiojByje"
		},
		{
			"name": "Mo i Rana",
			"lat": 66.3149,
			"lon": 14.1657,
			"link": ""
		},
		{
			"name": "Trondheim",
			"lat": 63.4305,
			"lon": 10.3951,
			"link": ""
		},
		{
			"name": "Honefoss",
			"lat": 60.1002,
			"lon": 10.0202,
			"link": ""
		},
		{
			"name": "Kristiansand",
			"lat": 58.1556,
			"lon": 8.0167,
			"link": ""
		},
		{
			"name": "Prague",
			"lat": 50.0755,
			"lon": 14.4378,
			"link": "https://discord.gg/4rZ2nGZB3r",
			"parent_name": "Czechia"
		},
		{
			"name": "Santiago",
			"lat": -33.4569,
			"lon": -70.6483,
			"link": "https://t.me/+VwLcz7MAIDg3MTFh"
		},
		{
			"name": "Vienna",
			"lat": 48.2082,
			"lon": 16.3738,
			"link": ""
		},
		{
			"name": "Halle (Saale)",
			"lat": 51.482,
			"lon": 11.97,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Freiburg",
			"lat": 47.999,
			"lon": 7.842,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Würzburg",
			"lat": 49.794,
			"lon": 9.929,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Bonn",
			"lat": 50.735,
			"lon": 7.1,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Leipzig",
			"lat": 51.34,
			"lon": 12.375,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Nürnberg",
			"lat": 49.4543,
			"lon": 11.0746,
			"link": "https://www.pause-ai.de/lokalgruppen",
			"parent_name": "Germany"
		},
		{
			"name": "Canberra",
			"lat": -35.2809,
			"lon": 149.13,
			"link": "https://www.pauseai.org.au",
			"parent_name": "Australia"
		},
		{
			"name": "Sydney",
			"lat": -33.8688,
			"lon": 151.2093,
			"link": "https://www.pauseai.org.au",
			"parent_name": "Australia"
		},
		{
			"name": "Brisbane",
			"lat": -27.4698,
			"lon": 153.0251,
			"link": "https://www.pauseai.org.au",
			"parent_name": "Australia"
		},
		{
			"name": "Perth",
			"lat": -31.9523,
			"lon": 115.8613,
			"link": "https://www.pauseai.org.au",
			"parent_name": "Australia"
		},
		{
			"name": "Adelaide",
			"lat": -34.9285,
			"lon": 138.6007,
			"link": "https://www.pauseai.org.au",
			"parent_name": "Australia"
		},
		{
			"name": "PauseAI en Español",
			"lat": 40.4168,
			"lon": -3.7038,
			"link": "https://chat.whatsapp.com/KEgD22LEo6xEVvjH4fD8br"
		},
		{
			"name": "Launceston",
			"lat": -41.433349,
			"lon": 147.123323,
			"link": "https://www.pauseai.org.au",
			"parent_name": "Australia"
		},
		{
			"name": "Manila",
			"lat": 14.6,
			"lon": 120.98,
			"link": ""
		},
		{
			"name": "Helsinki",
			"lat": 60.17,
			"lon": 24.95,
			"link": ""
		},
		{
			"name": "Osaka",
			"lat": 34.69,
			"lon": 135.5,
			"link": "",
			"parent_name": "Japan"
		},
		{
			"name": "Brussels",
			"lat": 50.85,
			"lon": 4.35,
			"link": "",
			"parent_name": "Belgium"
		},
		{
			"name": "Réunion Island",
			"lat": -21.115,
			"lon": 55.533,
			"link": "",
			"parent_name": "France"
		},
		{
			"name": "Veszprém",
			"lat": 47.1,
			"lon": 17.91,
			"link": ""
		},
		{
			"name": "Leicester",
			"lat": 52.6369,
			"lon": -1.1398,
			"link": "https://pauseai.uk/leicester/",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Hyderabad",
			"lat": 17.385,
			"lon": 78.4867,
			"link": ""
		},
		{
			"name": "Fukuoka",
			"lat": 33.5904,
			"lon": 130.4017,
			"link": "https://line.me/ti/g2/rrV7AC9zmKz802Yk-BvJcyb7fHdppCtDQ1RGxQ?utm_source=invitation&utm_medium=link_copy&utm_campaign=default",
			"parent_name": "Japan"
		},
		{
			"name": "Astana",
			"lat": 51.1694,
			"lon": 71.4491,
			"link": ""
		},
		{
			"name": "Geneva",
			"lat": 46.2044,
			"lon": 6.1432,
			"link": "",
			"parent_name": "Switzerland"
		},
		{
			"name": "Exeter",
			"lat": 50.7184,
			"lon": -3.5339,
			"link": "",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Oxford",
			"lat": 51.752,
			"lon": -1.2577,
			"link": "https://pauseai.uk/oxford/",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Glasgow",
			"lat": 55.8642,
			"lon": -4.2518,
			"link": "https://pauseai.uk/glasgow/",
			"parent_name": "United Kingdom"
		},
		{
			"name": "Porto",
			"lat": 41.1579,
			"lon": -8.6291,
			"link": "mailto:vpinto970@proton.me"
		},
		{
			"name": "Dhaka",
			"lat": 23.8103,
			"lon": 90.4125,
			"link": ""
		},
		{
			"name": "Potchefstroom",
			"lat": -26.7167,
			"lon": 27.1,
			"link": ""
		},
		{
			"name": "Brno",
			"link": "https://pauseai.cz",
			"lat": 49.19522,
			"lon": 16.60796,
			"parent_name": "Czechia"
		},
		{
			"link": "https://www.pause-ai.de/lokalgruppen",
			"name": "Münster",
			"lat": 51.96,
			"lon": 7.62,
			"parent_name": "Germany"
		},
		{
			"name": "Olomouc",
			"link": "https://chat.whatsapp.com/D8j1ci4PDonJJ8Rk15wKnb",
			"lat": 49.5925739,
			"lon": 17.2496039,
			"parent_name": "Czechia"
		}
	]
}
